var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expand-transition',[(_vm.expanded)?_c('v-layout',{staticClass:"gap-2",attrs:{"column":""}},_vm._l((_vm.childrenSteps),function(childrenStep){return _c('alarm-timeline-step',{key:childrenStep._id,attrs:{"step":childrenStep,"deep":""}})}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }